module.exports = __webpack_public_path__ + "static/media/bd-video-poster-lady-icons.7777014a.jpg";